export default {
    path: '/suggest',
    component: () => import('@/views/layout.vue'),
    redirect: '/suggest',
    name: 'suggest',
    sort: 2,
    icon: 'el-icon-user',
    meta: { title: '建议管理', authCode: ['SUGGESTTION'] },
    children: [
        {
            path: '/suggest',
            name: 'suggest',
            component: () => import('@/views/permission/suggest/suggest.vue'),
            meta: {
                title: '合理化建议',
                authCode: ['SUGGEST']
            }
        },
    ]
}
